module.exports = function() {};



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-json-inspector/lib/noop.js
 ** module id = 149
 ** module chunks = 0
 **/